import { MyPermissionsQuery } from '../../apis/graphql/types';
import { defaultPermissions } from '../../context/GlobalPermissions/constants';
import { GlobalPermissions } from '../../context/GlobalPermissions/types';

export const splitPermissionsData = (data?: MyPermissionsQuery['myPermissions']): GlobalPermissions => {
  const roles = data?.roles || [];
  const permissions = data?.permissions ?? defaultPermissions;
  const adAccountPermissions: GlobalPermissions['adAccountPermissions'] = data?.adAccountPermissions?.reduce(
    (acc, value) => ({ ...acc, [value.id]: value.permissions }),
    {}
  );

  return { roles, permissions, adAccountPermissions };
};
